// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import BobPage from '../../../components/BobPage';
import BackgroundJobsTableContainer from './BackgroundJobsTableContainer';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import classes from './BackgroundJobsList.module.css';

const BackgroundJobsPage = ({
    history,
    ...props
}) => {

    const handleBackClick = () => {
        if (history.location.search && history.location.state && history.location.state.returnUrl) {
            history.push({
                pathname: history.location.state.returnUrl,
                search:   `?${history.location.search}`
            });
        }
    };

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.TitlePanel}>
                        <div className={classes.Name}>
                            <span>
                                <span
                                    className={classes.BackIcon}
                                    aria-hidden="true"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() =>
                                        handleBackClick()
                                    }
                                >
                                    <i className="fas fa-chevron-left" />
                                </span>
                                { 'Background Jobs' }
                            </span> 
                        </div>
                    </div>
                </div>

                <div className={classes.DataPanel} />
                <div className={classes.TablePanel}>
                    <BackgroundJobsTableContainer />                    
                </div>
            </div>
        </BobPage>
    );
};

BackgroundJobsPage.defaultProps = {
};

BackgroundJobsPage.propTypes = {
};

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BackgroundJobsPage));
